import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BaseModalPlain from 'components/BaseModalPlain'
import './style.css'


class AppSubmitModal extends Component {

  static propTypes = {
    onCloseInitiated: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    animationSrc: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }

  render() {
    const { onCloseInitiated, title, animationSrc, description } = this.props

    return (
      <BaseModalPlain onCloseInitiated={onCloseInitiated}>
        <div className="app-submit-modal">
          <h1 className="app-submit-modal-title">
            {title}
          </h1>
          <video width="480" height="270" autoPlay>
            <source src={animationSrc} type="video/mp4" />
          </video>
          <p className="app-submit-modal-description">
            {description}
          </p>
        </div>
      </BaseModalPlain>
    )
  }
}

export default AppSubmitModal
